"use client";

import DitherShader from "@/components/ui/dither-shader";

type DitherCoverProps = {
  src: string;
  className?: string;
};

export function DitherCover({ src, className }: DitherCoverProps) {
  return (
    <DitherShader
      src={src}
      gridSize={3}
      ditherMode="bayer"
      colorMode="original"
      threshold={0.45}
      className={className}
    />
  );
}
